import { StudentIpAreaSelectContent } from './StudentIpAreaSelectContent';
export default StudentIpAreaSelectContent;